import { render, staticRenderFns } from "./BookingTranslations.vue?vue&type=template&id=8e4ce97e&scoped=true&"
import script from "./BookingTranslations.vue?vue&type=script&lang=js&"
export * from "./BookingTranslations.vue?vue&type=script&lang=js&"
import style0 from "./BookingTranslations.vue?vue&type=style&index=0&id=8e4ce97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ce97e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSnackbar,VSpacer,VTextField})
